import { FormattedMessage } from 'react-intl'

import { AccountSelectedStatus } from '@subaio/api-types/budget'
import type { Account } from '@subaio/api-types/psd2'
import { LoadingProvider, Placeholder } from '@subaio/components'

import { Cell } from 'components/Lists'
import { ProductLogo } from 'components/ProductLogo'

import { BankContainer } from './BankContainer'
import { Subtitle } from './Subtitle'

type Props = {
	title: string
	imageUrl: string | null
	isLoading?: boolean
	accounts: Array<Account> | null

	onClick?: () => void
}

export const ItemBank = ({ title, imageUrl, isLoading = false, accounts, onClick }: Props) => (
	<LoadingProvider value={isLoading}>
		<BankContainer disabled={!onClick} onClick={onClick}>
			<Cell>
				<ProductLogo title={title} imageUrl={imageUrl} size={48} />
			</Cell>
			<Cell shouldExpand>
				<Placeholder>{title}</Placeholder>
				{accounts && accounts.length > 0 && (
					<Subtitle>
						<Placeholder>
							<FormattedMessage
								id='bank.accounts'
								defaultMessage='{selected, plural, one {# of {total} account selected} other {# of {total} accounts selected}}'
								values={{
									selected: accounts.filter(({ selectedStatus }) => selectedStatus !== AccountSelectedStatus.Deselected)
										.length,
									total: accounts.length,
								}}
							/>
						</Placeholder>
					</Subtitle>
				)}
			</Cell>
		</BankContainer>
	</LoadingProvider>
)
